import * as React from 'react';
import { Text } from '../../Text';

import { ModalWindow } from '@cian/ui-kit/modal';
import { ICardItem, ISelectedPublication } from '../types';
import { PublicationContent } from '../PublicationContent';
import { trackPublicationClick } from './utils/tracking';

import { IGetPublicationParams } from '../../../types/redux';
import * as styles from './styles.css';

interface ICardProps extends ICardItem {
  className?: string;
  setSliderPause(isPaused: boolean): void;
  getPublication(payload: IGetPublicationParams): void;
  selectPublication(articleId: number): ISelectedPublication;
}

export const Card: React.FC<ICardProps> = props => {
  const { title, img, sourceName, setSliderPause, id, getPublication, selectPublication } = props;
  const [isOpen, setOpen] = React.useState<boolean>(false);

  const handleOpenPublication = () => {
    setOpen(true);
    setSliderPause(true);
    getPublication({ articleId: id });
    trackPublicationClick();
  };

  const handleClosePublication = () => {
    setOpen(false);
    setSliderPause(false);
  };

  return (
    <React.Fragment>
      <div className={styles['container']} onClick={handleOpenPublication}>
        {img && <img className={styles['img']} src={img} alt={`${sourceName}-icon`} />}
        <Text size="default" block>
          {title}
        </Text>
      </div>
      {isOpen && (
        <ModalWindow
          open={isOpen}
          width={800}
          fixed
          onClose={handleClosePublication}
          content={<PublicationContent articleId={id} selectPublication={selectPublication} />}
        />
      )}
    </React.Fragment>
  );
};

Card.displayName = 'Card';
